module.exports = __webpack_public_path__ + "img/1-A-Clearing-bg.5fe1f12a.png";